// extracted by css-extract-rspack-plugin
export default {"sidebarCollapseButton":"sidebarCollapseButton-GljEeN","sidebarSash":"sidebarSash-N8XGE2"};